import httpService from 'services/httpService.js';
import displayGlobalMessage from "./DisplayGlobalMessage";
import log from "loglevel";

const downloadFile = async (url) => {
    try {
        if (!url) return;
        if (Array.isArray(url)) {
            
            if  (url.length > 0) {
                log.log({url});
                url = url[0]?.uri;
                log.log({url});
            } else {
                log.log({url});
                throw new Error("Something is not right with url", "error");
            }
        }
        log.log(url?.split?.("/")[url.split("/").length - 1]);
        const response = await httpService.instance({
            url: url,
            method: 'GET',
            responseType: 'blob', // Important for handling binary data
        });
        const blob = response.data;

        const link = document.createElement('a');
        const objectURL = URL.createObjectURL(blob);
        link.href = objectURL;
        link.target = '_blank';

        // Create a timestamp with milliseconds
        const now = new Date();
        const timestamp = now
            .toISOString()
            .replace(/[-T:.Z]/g, '') // Remove unwanted characters
            .slice(0, 14); // Keep only YYYYMMDDHHMMSS
        const milliseconds = now.getMilliseconds().toString().padStart(3, '0'); // Pad milliseconds to 3 digits
        const fullTimestamp = `${timestamp}${milliseconds}`;

        const fileName = url?.split?.("/")[url.split("/").length - 1];
        link.download = `${fullTimestamp}_${fileName}`; 
        document.body.appendChild(link);
        link.click();
        
        // Remove the link and revoke the object URL
        document.body.removeChild(link);
        URL.revokeObjectURL(objectURL);
    } catch (err) {
        log.log(err, typeof err, {err});
        if (err?.message) {
            displayGlobalMessage(err?.message, "error");
        } else {
            displayGlobalMessage("Error occurred while downloading", "error");
        }
    }
}

export default downloadFile;